import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/ConfirmDialog';
import reportWebVitals from './reportWebVitals';

// ReactFlow's internal pane ResizeObserver can emit the benign "ResizeObserver loop
// completed with undelivered notifications" message, which CRA's DEV-only error
// overlay surfaces as a red error (it never reaches production). Defer observer
// callbacks to the next animation frame so the synchronous resize→layout→resize
// cycle never reaches the "undelivered notifications" condition — the message stops
// firing at the source, so neither the overlay nor any handler ever sees it.
// Standard ReactFlow/CRA workaround; the only effect is that resize-driven layout
// updates land one animation frame later (imperceptible).
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
